import { Checkbox, CheckboxVisibility, DetailsList, DetailsListLayoutMode, DetailsRow, Dropdown, IColumn, Icon, IDetailsRowProps, IDetailsRowStyles, IDropdownOption, PrimaryButton, TextField } from "@fluentui/react";
import * as React from "react";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import { RootState } from "~/state";
import TableHelper from "../utils/TableHelper";
import { getDebitorRuleSets } from "../../state/action";
import { addOrUpdateDebitorRuleSet, deleteDebitorRuleSet, getAllDebitorRuleSets, sortDebitorRuleSet } from "../../state/debitorRuleSets/action";
import TextFieldDelayedSave from "./TextFieldDelayedSave";
import { useParams } from "react-router";
import EditDebitor from "./EditDebitor";
import NavigationHelper from "../utils/NavigationHelper";

const debitorRulesetTypeDropdown:IDropdownOption<any>[] = [
    {key: "", text: "Not selected" },
    {key: "OFFER", text: "Tilbud" },
    {key: "INSURANCE", text: "Forsikring" },
    {key: "LEASING", text: "Leasing" },
    {key: "MIXED", text: "Mixed" },
]

function DebitorRuleset(props: StateProps)
{
    const { debitorNo } = useParams<{ debitorNo: string }>();
    const [sort, setSort] = React.useState<MapObject<SortDirection>>({});
    React.useEffect(() => { props.getAllDebitorRuleSets(); }, []);

    const dropDownTypeChange = (e: DebitorRuleSet) => (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption<any> | undefined, index?: number | undefined) => 
    {
        if(option && option.text)
        {
            const type:DebitorRuleSetType = option.key as DebitorRuleSetType;
            props.addOrUpdateDebitorRuleSet({...e, type});
        }
    }

    const onIsMandatoryChange = (e: DebitorRuleSet) => (ev: React.FormEvent<HTMLInputElement>, checked: boolean) => 
    {
        props.addOrUpdateDebitorRuleSet({...e, isMandatory: checked});
    }

    const  onColumnClick = (ev: React.MouseEvent<HTMLElement, MouseEvent>, column: IColumn) => 
    {
        let sortDirection: SortDirection = "UP";
        if(sort[column.key] === "UP")
        {
            sortDirection = "DOWN";
        }
        setSort({[column.key]:sortDirection})
        props.sortDebitorRuleSet(column.key as DebitorRuleSetSortList, sortDirection);
    }
    const sortedDirection = (key: string) =>
    {
        if(sort[key] === undefined)
        {
            return undefined;
        }
        return sort[key] === "DOWN";
    }

    const openSettings = (id: string) =>
    {
       NavigationHelper.pushRoute("DEBITOR_RULE_SET", "/" + id);
    }

    const isSorted =  (key: string) => sort[key] === undefined ? undefined : true;
    
    const columns: IColumn[] = [
            TableHelper.col("type", "Type", 100, 100, (e: DebitorRuleSet) =>
            {
                return <Dropdown selectedKey={e.type}  options={debitorRulesetTypeDropdown} onChange={dropDownTypeChange(e)} />;
            }, undefined, onColumnClick, isSorted("type"),  sortedDirection("type")),
            TableHelper.col("user", "Bruger", 125, 125, (e: DebitorRuleSet) =>
            {
                return <TextFieldDelayedSave value={e.user} onChange={(value: string) => props.addOrUpdateDebitorRuleSet({...e, user: value}) } />;
            }, undefined, onColumnClick, isSorted("user"),  sortedDirection("user")),
            TableHelper.col("owner", "Ejer", 125, 125, (e: DebitorRuleSet) =>
                {
                    return <TextFieldDelayedSave value={e.owner} onChange={(value: string) => props.addOrUpdateDebitorRuleSet({...e, owner: value}) } />;
                }, undefined, onColumnClick, isSorted("owner"),  sortedDirection("owner")),
            TableHelper.col("leasing", "Leasing", 207, 207, (e: DebitorRuleSet) =>
            {
                return <TextFieldDelayedSave value={e.leasing} onChange={(value: string) => props.addOrUpdateDebitorRuleSet({...e, leasing: value}) } />;
            }, undefined, onColumnClick, isSorted("leasing"),  sortedDirection("leasing")),
            TableHelper.col("insurrance", "Forsikring", 207, 207, (e: DebitorRuleSet) =>
            {
                return <TextFieldDelayedSave value={e.insurrance} onChange={(value: string) => props.addOrUpdateDebitorRuleSet({...e, insurrance: value}) } />;
            }, undefined, onColumnClick, isSorted("insurrance"),  sortedDirection("insurrance")),
            TableHelper.col("debitor", "Debitor", 95, 95, (e: DebitorRuleSet) =>
            {
                return <TextFieldDelayedSave value={e.debitor} onChange={(value: string) => props.addOrUpdateDebitorRuleSet({...e, debitor: value}) } />;
            }, undefined, onColumnClick, isSorted("debitor"), sortedDirection("debitor")),
            TableHelper.col("isMandatory", "Obligatorisk?", 85, 85, (e: DebitorRuleSet) =>
            {
                return <Checkbox checked={e.isMandatory} onChange={onIsMandatoryChange(e) } />;
            }),
            TableHelper.col("slet", "Slet", 80, 80, (e: DebitorRuleSet) =>
            {
                return <Icon style={{ fontSize: "20px",color: "darkred" }} iconName="Delete" onClick={() =>props.deleteDebitorRuleSet(e.id)} />;
            }),
            TableHelper.col("Setting", "Setting", 80, 80, (e: DebitorRuleSet) =>
            {
                return <Icon style={{ fontSize: "20px",}} iconName="Settings" onClick={() =>openSettings(e.debitor)} />;
            })
        ];
        const onRenderRow = (props: IDetailsRowProps): React.JSX.Element => {
            const customStyles: Partial<IDetailsRowStyles> = {};
    
            const item = props.item as DebitorRuleSet;
            if(item.type === "OFFER")
            {
                customStyles.cell = { background: "rgba(226, 219, 190, 0.3)" };
            }
            if(item.type === "INSURANCE")
            {
                customStyles.cell = { background: "rgba(157, 187, 174, 0.3)" };
            }
            if(item.type === "LEASING")
            {
                customStyles.cell = { background: "rgba(24, 143, 167, 0.3)" };
            }
            if(item.type === "MIXED")
            {
                customStyles.cell = { background: "rgba(213, 214, 170, 0.3)" };
            }
            
            return <DetailsRow {...props} styles={customStyles} />;
        };

    let editDebitor = null;
    
    if(debitorNo )
    {
        const debitor: DebitorRuleSet | undefined = props.debitorRuleset.find(d => d.debitor === debitorNo);
        if(debitor)
        {
            editDebitor = <EditDebitor debitor={debitor} />;
        }
        
    }
    return (
        <div
            style={{
                width: "1280px",
                margin: "40px auto 40px 0", // top, right, bottom, left
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                background: "#fff",
                boxShadow: "0 2px 16px rgba(0,0,0,0.08)",
                borderRadius: "12px",
                padding: "32px 24px",       
                position: "relative",
                left: "50%",
                transform: "translateX(-50%)"
            }}
        >
            <DetailsList 
                compact={true}
                indentWidth={0}
                className="hidden-xs assignments"
                layoutMode={DetailsListLayoutMode.fixedColumns}
                columns={columns}
                items={props.debitorRuleset}
                checkboxVisibility={CheckboxVisibility.hidden}
                onRenderRow={onRenderRow}
            />
            <PrimaryButton style={{ marginTop: 24 }} onClick={() =>props.addOrUpdateDebitorRuleSet()} >Add</PrimaryButton>
            {editDebitor}
        </div>
    );
}

const mapStateToProps = (state: RootState) =>
{
    return {
        debitorRuleset: getDebitorRuleSets(state)
    };
};

const mapToDispatchProps = (dispatch: Dispatch<Action>) =>
({
    getAllDebitorRuleSets: () => dispatch<any>(getAllDebitorRuleSets()),
    addOrUpdateDebitorRuleSet: (debitorRuleSet?: DebitorRuleSet) => dispatch<any>(addOrUpdateDebitorRuleSet(debitorRuleSet)),
    deleteDebitorRuleSet: (id: string) => dispatch<any>(deleteDebitorRuleSet(id)),
    sortDebitorRuleSet: (sortBy: DebitorRuleSetSortList, sortDirection: SortDirection) => dispatch<any>(sortDebitorRuleSet(sortBy, sortDirection)),
});

type StateProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapToDispatchProps>;

export default connect(mapStateToProps, mapToDispatchProps)(DebitorRuleset);